import React, { FC } from 'react'

import { InvitedUser } from 'components/InvitedUser'
import { User } from 'types'

export const UserList: FC<{
  users: Array<Partial<User>>
}> = ({ users }) => {
  return (
    <>
      <ul>
        {users.map(({ firstName, lastName, email, id }) => {
          const hasRegistered = !!firstName && !!lastName

          const textToRender = hasRegistered
            ? `${firstName} ${lastName}`
            : (email as string)

          return (
            id && (
              <InvitedUser
                isRegistered={hasRegistered}
                display={textToRender}
                id={id}
              />
            )
          )
        })}
      </ul>
    </>
  )
}
